import { emptyTheme } from '@fluentui/styles';
import * as React from 'react'; // @ts-ignore We have this export in package, but it is not present in typings

import { ThemeContext } from 'react-fela';
import getStyles from '../styles/getStyles';
var defaultContext = {
  disableAnimations: false,
  performance: {
    enableSanitizeCssPlugin: process.env.NODE_ENV !== 'production',
    enableStylesCaching: true,
    enableVariablesCaching: true,
    enableBooleanVariablesCaching: false
  },
  renderer: {
    renderRule: function renderRule() {
      return '';
    }
  },
  theme: emptyTheme
};

var useStyles = function useStyles(displayName, options) {
  var context = React.useContext(ThemeContext) || defaultContext;
  var _options$className = options.className,
      className = _options$className === void 0 ? process.env.NODE_ENV === 'production' ? '' : 'no-classname-🙉' : _options$className,
      _options$mapPropsToSt = options.mapPropsToStyles,
      mapPropsToStyles = _options$mapPropsToSt === void 0 ? function () {
    return {};
  } : _options$mapPropsToSt,
      _options$mapPropsToIn = options.mapPropsToInlineStyles,
      mapPropsToInlineStyles = _options$mapPropsToIn === void 0 ? function () {
    return {};
  } : _options$mapPropsToIn,
      _options$rtl = options.rtl,
      rtl = _options$rtl === void 0 ? false : _options$rtl; // Stores debug information for component.

  var debug = React.useRef({
    fluentUIDebug: null
  });

  var _getStyles = getStyles({
    // Input values
    className: className,
    displayName: displayName,
    props: Object.assign({}, mapPropsToStyles(), {}, mapPropsToInlineStyles()),
    // Context values
    disableAnimations: context.disableAnimations,
    renderer: context.renderer,
    rtl: rtl,
    saveDebug: function saveDebug(fluentUIDebug) {
      return debug.current = {
        fluentUIDebug: fluentUIDebug
      };
    },
    theme: context.theme,
    performance: context.performance
  }),
      classes = _getStyles.classes,
      resolvedStyles = _getStyles.styles;

  return {
    classes: classes,
    styles: resolvedStyles
  };
};

export default useStyles;